import React from 'react';
import { useSelector } from 'react-redux';
import { useLoaderData, useNavigate } from 'react-router-dom';
import { useImmer } from 'use-immer';

import Location from '@r6digital/rapidstor-types/react/entities/Location';

import { selectUnitData } from '../../store/bookingSlice';

import { usePostSaveQuoteMutation } from '../../features/rapidstor/rapidstorApiSlice';

import classes from './QuoteForm.module.scss';

import { logEvent } from '../../features/helpers';
import Spinner from '../Spinner';

function QuoteForm({ closeQuoteModal }: { closeQuoteModal: () => void }) {
    const navigate = useNavigate();
    const unitData = useSelector(selectUnitData);
    const location = useLoaderData() as Location;
    const [emailQuote, { isLoading }] = usePostSaveQuoteMutation();

    function submit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();
        if (!unitData || !unitData.unitType) return;

        emailQuote({
            locationCode: location.locationCode,
            payload: {
                customListing: true,
                sourceUrl: window.location.href,
                tenant: {
                    tenantId: null,
                    firstName: form.fname,
                    lastName: form.lname,
                    email: form.email,
                    phone: form.phone,
                },
                unitType: unitData.unitType._id,
            },
        })
            .then(() => {
                navigate(`/locations/${location.slug}/quote-sent`);
            })
            .catch((err: Error) => {
                logEvent(3, err.message);
            });
    }

    const [form, updateForm] = useImmer<Record<string, string>>({
        fname: '',
        lname: '',
        email: '',
        phone: '',
    });

    function update(key: string, event: React.BaseSyntheticEvent) {
        updateForm((draft) => {
            draft[key] = String(event.target.value);
            return draft;
        });
    }

    return (
        <div className={`${classes.backdrop}`}>
            <div className={`${classes.quote_card}`}>
                <div className={`${classes.header}`}>
                    <button style={{ opacity: 0 }} onClick={closeQuoteModal}>
                        Cancel
                    </button>
                    <span>
                        {unitData?.unitType.width}m x {unitData?.unitType.length}m Unit
                    </span>
                    <button className={`${classes.cancel}`} onClick={closeQuoteModal}>
                        Cancel
                    </button>
                </div>

                <div className={`${classes.copy}`}>
                    <span>Lock in your pricing</span>
                    <span>
                        Complete your details below to secure our current unit pricing
                    </span>
                </div>

                {isLoading ? (
                    <Spinner size={100} />
                ) : (
                    <form onSubmit={submit}>
                        <input
                            type='text'
                            placeholder='First Name'
                            required
                            onChange={(e) => update('fname', e)}
                        />
                        <input
                            type='text'
                            placeholder='Last Name'
                            required
                            onChange={(e) => update('lname', e)}
                        />
                        <input
                            type='text'
                            placeholder='Phone'
                            required
                            onChange={(e) => update('phone', e)}
                        />
                        <input
                            type='email'
                            placeholder='Email'
                            required
                            onChange={(e) => update('email', e)}
                        />
                        <button type='submit'>Save Pricing</button>
                    </form>
                )}
            </div>
        </div>
    );
}

export default QuoteForm;
